import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { DataGrid, GridId } from 'view/components/datagrid'
import { createHaircutGridColumnDefs, haircutGridOptions, HAIRCUT_VALUES_FIELDNAME } from './HaircutGridModel'
import { HaircutEntryDetail, HaircutBand, HaircutEntry, CrudActions, CrudEventEnum } from 'api'
import { haircutEntryDetailsSelector, haircutBandSelector } from 'selectors/haircutSelectors'
import { populateValuesByBand } from '../utils'

interface HaircutGridProps {
  haircutBands: HaircutBand[]
  haircutEntryDetails: HaircutEntryDetail[]
  onUpsert: (haircutEntry: HaircutEntry) => unknown
}

const mapStateToProps = createStructuredSelector({
  haircutBands: haircutBandSelector,
  haircutEntryDetails: haircutEntryDetailsSelector
})

const mapDispatchToProps = {
  onUpsert: CrudActions.haircutEntryUpsert
}

export class HaircutGridComponent extends React.Component<HaircutGridProps> {
  render() {
    // the grid might render before the haircut bands are loaded
    // so we need to recompute the column defs on each render
    // ag-grid compares column defs for equality using colId which
    // means that once the set is stable the grid is unaffected by their recreation
    const columnDefs = createHaircutGridColumnDefs(this.props.haircutBands)
    return (
      <DataGrid
        gridId={GridId.HaircutGrid}
        gridOptions={haircutGridOptions}
        columnDefs={columnDefs}
        rowData={this.props.haircutEntryDetails}
        canEditRow={this.canEditRow}
        onCellValueUpdated={this.handleCellValueUpdated}
      />
    )
  }

  canEditRow = (haircutEntryDetail: HaircutEntryDetail) => {
    return haircutEntryDetail.availableEvents.includes(CrudEventEnum.UPSERT)
  }

  handleCellValueUpdated = (_haircutEntryId: string, haircutEntryDetail: HaircutEntryDetail, field: string, newValue: string) => {
    const regExp = new RegExp(`${HAIRCUT_VALUES_FIELDNAME}\\[(\\d+)\\]`, 'g')
    const bandIdMatches = regExp.exec(field)
    if (bandIdMatches && bandIdMatches.length === 2) {
      const bandId = bandIdMatches[1]
      const valuesByBand = populateValuesByBand(haircutEntryDetail.haircutEntry.valuesByBand, newValue, bandId, this.props.haircutBands)

      const haircutEntry: HaircutEntry = {
        ...haircutEntryDetail.haircutEntry,
        valuesByBand: { ...valuesByBand, [bandId]: Number(newValue) }
      }

      this.props.onUpsert(haircutEntry)
    }
  }
}

export const HaircutGrid = connect(mapStateToProps, mapDispatchToProps)(HaircutGridComponent)
